import { Provider } from '@repo/api-gw-sdk';
import { useRestoreAccounts } from '@/app/(dashboard)/settings/restore-accounts/useRestoreAccounts';
import { createCloudProviderCondition } from '@/components/cloudProviders/createCloudProviderCondition';
import { useDAL } from '@/contexts/useDAL';
import { getKmsKeyPolicyStatements } from './kmsPolicyUtils';
import { CopyableCode } from '../shared/copyableCode';
export const KmsCopyablePolicy = ({
  cloudProvider,
  withRestoreAccounts = true
}: {
  cloudProvider: Provider;
  withRestoreAccounts?: boolean;
}) => {
  const dal = useDAL();
  const {
    data: scanningAccounts,
    isLoading: isLoadingScanningAccounts
  } = dal.cloudAccounts.scanning.useList();
  const {
    data: restoreAccounts,
    isLoading: isLoadingRestoreAccounts
  } = useRestoreAccounts(createCloudProviderCondition([Provider.Aws]));
  const filteredScanningAccounts = scanningAccounts?.accounts.filter(a => a.cloudProvider === cloudProvider);
  const isLoading = isLoadingScanningAccounts || isLoadingRestoreAccounts;
  if (!isLoading && (filteredScanningAccounts?.length ?? 0) === 0) {
    console.error("Expected at least one scanning account for the vault's cloud provider, found 0");
    return null;
  }
  const scanningAccountIds = (filteredScanningAccounts ?? []).map(a_0 => a_0.providerAccountId);
  return <CopyableCode blur={isLoading} title='policy.json' code={getKmsKeyPolicyStatements(scanningAccountIds, withRestoreAccounts ? restoreAccounts?.accounts ?? [] : [])} maxHeight='320px' />;
};